export default __webpack_public_path__ + "static/card-visa-gold-7881e2bb01a0740de02ad705df27d6c8.png";